import React, { Component } from 'react';
import { Card, CardBody, Alert, Col, Row } from 'reactstrap';
import { connect } from "react-redux";

class Error extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorString: props.errorString ? props.errorString : ""
        };
    }

    render() {
        return (
            <div>
                <Row>
                    <Col>
                        <Alert color="danger">
                            <div className='p-3' dangerouslySetInnerHTML={{ __html: this.state.errorString}}></div>
                        </Alert>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { errorString } = state.newLoan;
    return {
        errorString
    };
}

const connectedError = connect(mapStateToProps)(Error);
export { connectedError as Error };
